import React from "react";
import {
  Typography,
  Divider,
} from "@mui/material";
import Herring from "../images/Herring.png"
import Grosz from "../images/Grosz.png"

export default function Article2(props: any) {

  return (
    <div>
      <title>“Who’d We Get?” - A Rockies Trade Deadline Recap (ft. Isaac Stevens of Blake Street Banter)
      </title>
      <Typography
        variant="h4"
        component="h1"
        style={{
          fontWeight: "bold",
          color: "#000000",
          textAlign: "center",
          fontSize: props.isDesktop ? "34pt" : "20pt",
        }}
      >
        “Who’d We Get?” - A Rockies Trade Deadline Recap (ft. Isaac Stevens of Blake Street Banter)
      </Typography>
      <Typography
        variant="h6"
        style={{
          fontWeight: "bold",
          marginBottom: "12px",
          color: "rgba(0, 0, 0, 0.7)",
          textAlign: "center",
          fontSize: props.isDesktop ? "18pt" : "14pt",
        }}
      >
        By Isaac Stevens • August 11th, 2025
      </Typography>
      <Divider variant="middle" style={{ marginBottom: "20px" }} />

      <>
        <Typography
          variant="body2"
          style={{
            color: "rgba(0, 0, 0, 1)",
            fontSize: "13pt"
          }}
        >
          The Rockies are a historically incompetent team when it comes to selling at the trade deadline. In recent memory, the Rockies have held onto the likes of Trevor Story, Jon Gray, Daniel Bard, and many others at peak value. So, going into the 2025 deadline as one of the worst teams in the modern era, the Rockies had an opportunity to turn around their past mistakes. And that’s what they did.
          <br /><br />
        </Typography>

        <div style={{ margin: "auto", width: "500px", marginBottom: "20px" }}>
          <img
            src={"https://img.mlbstatic.com/mlb-images/image/upload/ar_16:9,g_auto,q_auto:good,w_1024,c_fill,f_jpg/mlb/ypvwwihjikdupffhskum"}
            alt="Rockies trade deadline graphic"
            style={{ maxWidth: "75vw", maxHeight: "400px", border: "#293241 solid 2px" }}
          />
        </div>

        <Typography
          variant="body2"
          style={{
            color: "rgba(0, 0, 0, 1)",
            fontSize: "13pt"
          }}
        >
          The Rockies traded longtime third baseman Ryan McMahon while also sending relievers Tyler Kinley and Jake Bird away this deadline. We will use Prospect Savant’s statistics to figure out who the prospects the Rockies got in return are.
        </Typography>
        <div style={{
          margin: "20px 0",
          padding: "15px",
          backgroundColor: "#f8f9fa",
          borderLeft: "4px solid #0d6efd",
          borderRadius: "4px"
        }}>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Yankees Receive:</div>
            <div style={{ flex: 2, fontSize: "14pt" }}>3B Ryan McMahon</div>
          </div>
          <div style={{ display: "flex" }}>
            <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Rockies Receive:</div>
            <div style={{ flex: 2, fontSize: "14pt" }}>
              LHP <a href="/player/702622" style={{ color: "#0d6efd", textDecoration: "none" }}>Griffin Herring</a> (NYY #8),<br />
              RHP <a href="/player/701056" style={{ color: "#0d6efd", textDecoration: "none" }}>Josh Grosz</a> (NYY #21)
            </div>
          </div>
        </div>

        <Typography
          variant="body2"
          style={{
            color: "rgba(0, 0, 0, 1)",
            fontSize: "13pt"
          }}
        >
          Trading Ryan McMahon signaled that the Rockies are finally deciding to rebuild. Often in franchise history, they stick with familiar faces—many of whom would never be part of playoff runs. This is the first time since the Troy Tulowitzki trade in 2015 that the Rockies traded a position player not on an expiring contract at the deadline. Not only did the Rockies receive two solid prospects, they also opened up space at third base going forward. This move creates much more future leverage than Rockies fans are used to.
          <br /><br />
        </Typography>

        <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
          LHP Griffin Herring
        </Typography>
        <br />

        <Typography
          variant="body2"
          style={{
            color: "rgba(0, 0, 0, 1)",
            fontSize: "13pt"
          }}
        >
          At the time of the trade, Griffin Herring had the second-lowest ERA in Minor League Baseball, just one year after being selected in the 6th round. When the Yankees selected Herring, they knew they had a good pitcher but aimed to make him better. They raised his arm slot and increased his changeup usage, resulting in one of MiLB’s best pitchers. Prospect Savant’s numbers paint the bigger picture:
          <br /><br />
        </Typography>

        <div style={{ textAlign: "center", margin: "20px 0" }}>
          <img
            src={Herring}
            alt="Griffin Herring stats"
            style={{ maxWidth: "90%", border: "#293241 solid 2px" }}
          />
        </div>

        <Typography
          variant="body2"
          style={{
            color: "rgba(0, 0, 0, 1)",
            fontSize: "13pt"
          }}
        >
          His fastball averages almost 91 MPH, so he isn’t blowing anyone away with velocity. You’d think his other pitches must have devastating peripherals, yet only one is exceptionally better than league average in psStuff+ (his sinker at 110). So, are his amazing results a fluke? Wrong. If Statcast measured deception, Herring would have an all-red bar in the 100th percentile. His delivery isn’t smooth or slow, and there’s no hitch. Whatever causes the deception hasn’t been figured out in MiLB, resulting in his 1.78 ERA in 96.1 IP. The only concern is his velocity and whether it will play at the big-league level. The hope is that adding an extra couple ticks will put him on track to being a MLB starter.
          <br /><br />
        </Typography>

        <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
          RHP Josh Grosz
        </Typography>
        <br />

        <Typography
          variant="body2"
          style={{
            color: "rgba(0, 0, 0, 1)",
            fontSize: "13pt"
          }}
        >
          <div style={{ textAlign: "center", margin: "20px 0" }}>
          <img
            src={Grosz}
            alt="Josh Grosz stats"
            style={{ maxWidth: "90%", border: "#293241 solid 2px" }}
          />
        </div>
          A 2023 11th-round pick, Grosz has been a reliable starter through his minor league career. Across just over 200 innings (mostly in Single-A and High-A), he has a career 4.20 ERA while striking out more than one batter per inning. The right-hander climbed to become the Yankees' #21 prospect and has been assigned to the Rockies’ High-A affiliate. Since college, his command has improved yearly, and the large strides he takes every offseason add another layer of intrigue.
          <br /><br />
          Grosz features a low-to-mid 90s fastball that averaged 15 inches of arm-side movement in his 2024 stint with Low-A Tampa. His changeup has similar shape (psStuff+ 107) and induces chase. Rounding out the 22-year-old’s repertoire is a slider that lives on the horizontal axis but struggles with consistent movement. Grosz dials it up to 97 MPH, showing more power than his average velocity suggests. With his lethal changeup and developing slider, if he can sit 94-96, he could become a potential back-end starter in a season or two.
          <br /><br />
        </Typography>

        <div style={{
          margin: "20px 0",
          padding: "15px",
          backgroundColor: "#f8f9fa",
          borderLeft: "4px solid #dc3545",
          borderRadius: "4px"
        }}>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Braves Receive:</div>
            <div style={{ flex: 2, fontSize: "14pt" }}>RHP Tyler Kinley</div>
          </div>
          <div style={{ display: "flex" }}>
            <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Rockies Receive:</div>
            <div style={{ flex: 2, fontSize: "14pt" }}>
              RHP Austin Smith (unranked)
            </div>
          </div>
        </div>

        <Typography
          variant="body2"
          style={{
            color: "rgba(0, 0, 0, 1)",
            fontSize: "13pt"
          }}
        >
          Tyler Kinley’s Rockies career saw significant struggle. An experimental pickup in 2019, Kinley spent a long time in the organization with many ups and downs. Notably, he has allowed the most runs of any reliever in baseball since 2024. This doesn’t mean Kinley is bad—fly-ball pitchers with below-average command rarely succeed at Coors Field. At surface level, Kinley is not great. However, his individual pitch metrics are above average, and his expected statistics indicate bad luck. It’s no surprise the Rockies traded him for another experimental pitcher.
          <br /><br />
        </Typography>

        <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
          RHP Austin Smith
        </Typography>
        <br />

        <Typography
          variant="body2"
          style={{
            color: "rgba(0, 0, 0, 1)",
            fontSize: "13pt"
          }}
        >
          Among prospects traded at the 2025 deadline, Austin Smith may be the most unique pitcher. He doesn’t throw from a funky slot or have wild mound presence—so what makes him unique? At the time of the trade, he was 26 with a Double-A ERA of 5.40, unranked on any top prospect lists, and had a history of injuries that stalled his development. Why trade Kinley for this guy?
          <br /><br />
          Smith does two things well: 1) touches the upper 90s with his fastball, and 2) gets around 7 feet of extension. Unfortunately, he’s never pitched in a league with Statcast, so we can’t use Prospect Savant. However, a fastball with that much power is an MLB-caliber pitch regardless of shape. The righty also offers a loopy slider that pairs well with his fastball when he has good feel. Everything about him is raw, but the ceiling of a big-league middle reliever is intriguing. While the Rockies could’ve traded for a younger, higher-risk prospect, Smith fits the archetype of a successful Rockies pitcher.
          <br /><br />
        </Typography>

        <div style={{
          margin: "20px 0",
          padding: "15px",
          backgroundColor: "#f8f9fa",
          borderLeft: "4px solid #0d6efd",
          borderRadius: "4px"
        }}>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Yankees Receive:</div>
            <div style={{ flex: 2, fontSize: "14pt" }}>RHP Jake Bird</div>
          </div>
          <div style={{ display: "flex" }}>
            <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Rockies Receive:</div>
            <div style={{ flex: 2, fontSize: "14pt" }}>
              2B <a href="/player/691792" style={{ color: "#0d6efd", textDecoration: "none" }}>Roc Riggio</a> (NYY #10),<br />
              LHP <a href="/player/815456" style={{ color: "#0d6efd", textDecoration: "none" }}>Ben Shields</a> (NYY #28)
            </div>
          </div>
        </div>

        <Typography
          variant="body2"
          style={{
            color: "rgba(0, 0, 0, 1)",
            fontSize: "13pt"
          }}
        >
          A year ago, the Rockies traded controllable reliever Nick Mears to the Brewers. Similarly, Jake Bird is a controllable reliever traded at this deadline—but he’s having one of the weirdest seasons in recent memory. In his first 28 games, he had an elite 1.41 ERA with 50 strikeouts versus 15 walks in 38.1 IP. Since then, Bird has a 14.82 ERA across 17 IP with 16 strikeouts and 10 walks. That the Rockies got such a good haul for one of baseball’s worst pitchers at the time is remarkable. Despite Bird’s poor numbers, his pitch metrics (especially his breaking balls) are among MLB’s nastiest. After a recent demotion, the Yankees hope extra time will help him regain his early-season form.
          <br /><br />
          Acquiring Roc Riggio is also the first time since 2012 (Charlie Culberson for Marco Scutaro) that the Rockies acquired a position player prospect at the deadline.
          <br /><br />
        </Typography>

        <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
          2B Roc Riggio
        </Typography>
        <br />

        <Typography
          variant="body2"
          style={{
            color: "rgba(0, 0, 0, 1)",
            fontSize: "13pt"
          }}
        >
          Perhaps the best prospect the Rockies received, Roc Riggio is amidst a breakout season. After hitting .221 with 11 HRs in 2024, he’s turned his career around entirely. He’s improved his average to .264 and has already hit 18 HRs in nearly 40 fewer games. The 5’9” second baseman draws comparisons to Rougned Odor—one the Rockies will gladly take.
          <br /><br />
          Riggio is extremely patient. He knows the zone well and rarely chases bad pitches. This approach led to a 12% walk rate in 2025 (likely to decrease as he faces better pitchers). So, he gets on base well—but how does he hit? When he swings, he swings hard and aggressively, generating impressive power for his stature. At the time of the trade, Riggio had a hard-hit rate over 50%. While his raw power isn’t elite, projecting 20 HRs at the MLB level isn’t a reach given his hard-contact consistency.
          <br /><br />
        </Typography>

        <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
          LHP Ben Shields
        </Typography>
        <br />

        <Typography
          variant="body2"
          style={{
            color: "rgba(0, 0, 0, 1)",
            fontSize: "13pt"
          }}
        >
          One of the first things you may notice about Ben Shields is that he went undrafted—but don’t let that define him. Averaging just 90 MPH on his fastball with a 5.16 career ERA in college, he was a professional afterthought. Then, after signing with the Yankees before 2024, he posted two straight seasons with a 3.38 ERA in the minors. How?
          <br /><br />
          While Shields once threw just 90 MPH, he now sits 92-95 MPH from a lower left-handed slot—an uncomfortable look for hitters. Prospect Savant gave his fastball a 109 psStuff+. The lefty pairs it with two breaking balls: a sweeping slider on the horizontal axis and a loopier curveball with more drop. Nothing is flashy, but his solidity profiles him as a future middle-inning reliever. Credit the Yankees for finding diamonds in the rough like Shields.
          <br /><br />
        </Typography>

        <Typography
          variant="body2"
          style={{
            color: "rgba(0, 0, 0, 1)",
            fontSize: "13pt"
          }}
        >
          <a href="https://blakestreetbanter.com/2025/08/02/rockies-deadline-review/">Read Here to see Blake Street Banter’s 2025 Rockies Trade Deadline Grades.</a>
          <br /><br />
          Thank you for reading! If you enjoyed this, check out <a href="https://blakestreetbanter.com/">Blake Street Banter</a> for all things Rockies-related. If you’re into podcasts, BSB is the place for you. For informative Rockies content, find us on every social media platform.
          <br /><br />
          Blake Street Banter (@blakestbanter)<br />
          Isaac Stevens (@coachfunnyman11)
        </Typography>
      </>
    </div>
  );
}
